export const fetchAppSlider = async () =>
    import('./components/app-slider' /* webpackChunkName: "AppSlider" */).then((m) => m.default);

export const fetchSwiper = async () => import('swiper' /* webpackChunkName: "swiper" */);

export const fetchIMask = async () => import('imask' /* webpackChunkName: "imask" */).then((m) => m.default);
